import { Component, ViewChild ,OnInit} from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';

import { MatDialogModule } from '@angular/material/dialog';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatMenuModule } from '@angular/material/menu';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatProgressBarModule} from '@angular/material/progress-bar';

import { BaseChartDirective } from 'ng2-charts'; 
import { ChartConfiguration, ChartData,Chart} from 'chart.js';
import { ChartOptions, ChartType } from 'chart.js';
import { ChartDataset } from 'chart.js';

import { AnalysisOptionsComponent } from '../../tools/analysis-options/analysis-options.component';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { FacadeService } from '../../services/facade.service';

import annotationPlugin from 'chartjs-plugin-annotation';  // Importar el plugin
import { ProyectosService } from '../../services/proyectos.service';

// Registrar el plugin en Chart.js
Chart.register(annotationPlugin);


@Component({
  selector: 'lexical-free',
  standalone: true,
  imports: [MatDialogModule,
    CommonModule,
    RouterOutlet,
    MatSidenavModule,
    MatExpansionModule,
    MatToolbarModule,
    MatIconModule,
    MatListModule,
    MatCardModule,
    MatButtonModule,
    MatInputModule,
    MatSelectModule,
    MatCheckboxModule,
    MatMenuModule,
    MatSlideToggleModule,
    MatProgressBarModule,
    AnalysisOptionsComponent,
    BaseChartDirective,
    HttpClientModule],
  templateUrl: './lexical-free.component.html',
  styleUrl: './lexical-free.component.css'
})
export class LexicalFreeComponent implements OnInit{
  public diversity={
    vocd:null,
    mtld:null,
    too_short_error:false
  }
  project_data: any;
  char_vocd = 0;

  private proyectoSub;

  loaderActive: boolean;
  loaderActive2: boolean;
  loaderActiveFirstProject: boolean;

  verifyLoaderActive2: boolean;

  lexical_short_words: boolean;

  constructor(
    private http: HttpClient,
    public fachada: FacadeService,
    public proyectoService: ProyectosService
  ) { }

  getBoxLineColorVOCD(value: number): string {
    if (value >= 0 && value <= 70) {
      return 'box-line-green';
    } else if (value > 70 && value <= 80) {
      return 'box-line-yellow';
    } else if (value > 80) {
      return 'box-line-red';
    }
    return 'box-line';
  }

  getBoxLineColorMTLD(value: number): string {
    if (value >= 0 && value <= 70) {
      return 'box-line-green';
    } else if (value > 70 && value <= 80) {
      return 'box-line-yellow';
    } else if (value > 80) {
      return 'box-line-red';
    }
    return 'box-line';
  }

  getTextLineVOCD(value: number): string {
    if (value >= 0 && value <= 70) {
      return 'Low Vocabulary Diversity';
    } else if (value > 70 && value <= 80) {
      return 'Medium Vocabulary Diversity';
    } else if (value > 80) {
      return 'High Vocabulary Diversity';
    }
    return '';
  }

  getTextLineMTLD(value: number): string {
    if (value >= 0 && value <= 70) {
      return 'Low Vocabulary Diversity';
    } else if (value > 70 && value <= 80) {
      return 'Medium Vocabulary Diversity';
    } else if (value > 80) {
      return 'High Vocabulary Diversity';
    }
    return '';
  }

  ngOnInit(): void {
    localStorage.setItem("actual","lexicalF")
    this.initSubscribe()
      if(sessionStorage.getItem("id_project")){
    this.initDiversity()
     }
    if(sessionStorage.getItem("text_UID")){
      this.loaderActive = true;
    }
     this.proyectoService.loader$.subscribe(loader => {
      if(this.loaderActive2){
        this.loaderActive = false;
      }else{
        this.loaderActive = loader;
      }
    });

                this.proyectoService.loaderAnalyzing$.subscribe(loader => {
      if(loader){
        this.loaderActive2 = true;
      }
      if(!loader){
        this.loaderActive2 = false;
      }
    });

         this.proyectoService.loaderCreatingProject$.subscribe(value => {
      if(value){
        this.loaderActive2 = true;
      }
      if(!value){
        this.loaderActive2 = false;
      }
    });

     this.proyectoService.verifyloaderAnalyzing$.subscribe(value => {
      if(value){
        this.verifyLoaderActive2 = true;
      }
      if(!value){
        this.verifyLoaderActive2 = false;
      }
    });

     setInterval(() => {
       let pantalla_actual = localStorage.getItem("actual")
    if (pantalla_actual == "lexicalF" && sessionStorage.getItem("lexical") !== "-" && !this.loaderActive && sessionStorage.getItem("id_project") && !this.verifyLoaderActive2){
       this.loaderActive2 = false;
          this.loaderActive = false;
          this.loaderActiveFirstProject = false;
          this.proyectoService.updateloader(false);
          this.initDiversity()
      }
      }, 20 * 1000); // 30 segundos
  }

  initSubscribe() {
      if (!this.proyectoSub || this.proyectoSub.closed) {
    //Subscribimos al servicio para escuchar los datos
    this.proyectoSub = this.proyectoService.proyecto$.subscribe(({ proyecto, firstProject })=>{
       if(!firstProject){
          this.loaderActive = false;
          if(sessionStorage.getItem("text_UID")){
            if(!this.loaderActiveFirstProject){
              this.loaderActive2 = true;
            }
          }else{
            this.loaderActive2 = false;
          }
        }
        if(firstProject){
          this.loaderActive = false;
          if(sessionStorage.getItem("text_UID")){
            this.loaderActiveFirstProject = true;
          }else{
            this.loaderActiveFirstProject = false;
          }
        }
      console.log("Update de data --Reporta: Lexical Diversity--")
      this.project_data = proyecto;
      if(sessionStorage.getItem("id_project")){
        this.initDiversity();
        }
    });
  }
  }


   status: any;
  async initDiversity(){
    let pantalla_actual = localStorage.getItem("actual")
    if (pantalla_actual == "lexicalF"){
      // Intentar recuperar el resumen desde sessionStorage
      const memoryStorage = sessionStorage.getItem("lexical");
  
      if (memoryStorage) {
        if(memoryStorage !== "-"){
        try {
          // Si existe, convertirlo de JSON string a objeto y asignarlo
          this.diversity = JSON.parse(memoryStorage);
          this.lexical_short_words = this.diversity.too_short_error;
          this.char_vocd = this.diversity.vocd
          await this.start_chart()
          // this.config.options.plugins.annotation.annotations.line1.value
        } catch (error) {
           if (error.message.includes("Canvas is already in use")) {
            console.log("Error en la petición de datos")
            console.log(error)
            } else {
              sessionStorage.removeItem('lexical');
            }
  
        }finally{
          this.loaderActive2 = false;
          this.loaderActive = false;
          this.loaderActiveFirstProject = false;
          this.proyectoService.updateloader(false);
        }
        }
      }
      else{
        sessionStorage.setItem("lexical", "-");
         //Tenemos que esperar unos milisegundos en lo que el servicio actualiza la info
        await new Promise(resolve => setTimeout(resolve, 10));
        try {
          let textUID = sessionStorage.getItem('text_UID');
          let respuesta = await this.fachada.getLexicalDiversityOfProject(this.http,textUID,"");
          this.diversity = respuesta;
          // Guardar la respuesta en sessionStorage
          sessionStorage.setItem("lexical", JSON.stringify(this.diversity));
          this.lexical_short_words = this.diversity.too_short_error;
          this.char_vocd = this.diversity.vocd
          await this.start_chart()
          this.status = 200
          // this.config.options.plugins.annotation.annotations.line1.value
        } catch (error) {
           if (error?.status === 0) {
            console.error("Error 500: Error interno del servidor (lexical)");
            sessionStorage.removeItem('lexical');
            this.status = 0

          }
            if (error.message.includes("Canvas is already in use")) {
            console.log("Error en la petición de datos")
            console.log(error)
            } else {
              sessionStorage.removeItem('lexical');
            }
            this.status = error?.status;
        }finally{
          if (this.status === 0) {
            this.loaderActive2 = true;
            this.loaderActive = true;
            this.loaderActiveFirstProject = true;
            this.proyectoService.updateloader(true);
            setTimeout(() => {
              this.initDiversity();
            }, 100);
          }else{
            this.loaderActive2 = false;
            this.loaderActive = false;
            this.loaderActiveFirstProject = false;
            this.proyectoService.updateloader(false);
             setTimeout(() => {
              this.initDiversity();
            }, 100);
          }
         
          
        }
      }
    }else{
      console.log(`lexical no es la pantalla actual así que bloqueamos peticiones`)
    }
   
  }

  async start_chart(){
        
    const data: ChartData<'bar'> = {
      labels: ["","",'Academic Text', 'Adult ESL','6+ MFL French', '60 months', '42 months', '36 months', '30 months', '24 months', '18 months' ],
      datasets: [
        {
          label: 'Dataset 1',
          data: [
            null, null,
            [155, 170], [70, 110], [65, 125], [110, 130], [60, 100], [50, 90], [40, 80] ,[5, 50], [5, 35]
          ],
          backgroundColor: [
            'transparent', 'transparent','#F66B2D', '#F66B2D', '#F66B2D', '#F66B2D', '#F66B2D', '#F66B2D', '#F66B2D', '#F66B2D', '#F66B2D'
          ],
          borderColor: [
            'transparent', 'transparent','#2A3654', '#2A3654', '#2A3654', '#2A3654', '#2A3654', '#2A3654', '#2A3654', '#2A3654', '#2A3654'
          ],
          borderWidth: 1,
          barThickness: 35, 
          borderSkipped: false
        },
        {
          label: 'Dataset 2',
          data: [null, null,
            [0, 25], [0, 40], [0, 60], [0, 20], [0, 40], [0, 40], [0, 40], [0, 45], [0, 30]
          ],
          backgroundColor: [
            'transparent', 'transparent','#F66B2D', '#F66B2D', '#F66B2D', '#F66B2D', '#F66B2D', '#F66B2D', '#F66B2D', '#F66B2D', '#F66B2D'
          ],
          borderColor: [
            'transparent', 'transparent','#2A3654', '#2A3654', '#2A3654', '#2A3654', '#2A3654', '#2A3654', '#2A3654', '#2A3654', '#2A3654'
          ],
          borderWidth: 1,
          barThickness: 35 
        }
      ]
    };


    let config: ChartConfiguration<'bar'> = {
      type: 'bar',
      data: data,
      options: {
        devicePixelRatio: 2, // Aumenta la resolución
        indexAxis: 'y',
        maintainAspectRatio: false,
        plugins: {
          title: {
            display: true,
            text: 'Bristol Charts',
            color:"black",
            font: {
              size: 14,
              family:'Inter'
            }
          },
          datalabels: {
              display: false // Desactiva los datalabels solo en este gráfico
            },
          legend: {
            display: false
          },
          annotation: {
            annotations: {
              line1: {
                type: 'line',
                scaleID: 'x',
                value: this.diversity.vocd, // Posición de la línea VOCD
                borderColor: 'black',
                borderWidth: 2,
                borderDash: [5, 5],
                label: {
                  display: true,
                  content: 'VOCD',
                  font:{
                    family: 'Inter',
                  },
                  position: 'start',
                  
                },
                
              },
              line2: {
                type: 'line',
                scaleID: 'x',
                value: this.diversity.mtld, // Posición de la línea MTLD
                borderColor: 'black',
                borderWidth: 2,
                borderDash: [5, 5],
                label: {
                  display: true,
                  content: 'MTLD',
                  font:{
                    family: 'Inter',
                  },
                  position: 'start',
                  
                },
                
              }
            }
          }
        },
        responsive: true,
        scales: {
          x: {
            stacked: true,
            grid: {
              display: false // Oculta las líneas de fondo horizontales
            },
            ticks: {
              color: 'black' // Color negro para los valores del eje x
              ,font:{
                family: 'Inter',
              }
            },
            border: {
              color: 'black' // Cambia el color de la línea del eje y a negro
            }
          },
          y: {
            stacked: true,
            grid: {
              display: true,
              color: (context) => {
                if (context.tick && (context.tick.label === 'Academic Text' || context.tick.label === 'Adult ESL')) {
                  return 'transparent'; // Oculta las líneas de fondo para las dos primeras etiquetas
                }
                return '#e0e0e0'; // Color de las líneas de fondo para las demás etiquetas
              },
              
            },
            
            ticks: {
              color: 'black', // Color negro para los valores del eje x
              align: 'end',
              crossAlign: 'near',
              font:{
                family: 'Inter',
              }
            },
            border: {
              color: 'black' // Cambia el color de la línea del eje y a negro
            }
          }
          
        },
      }
    };

    const myChart = new Chart(
      document.getElementById('myChart') as HTMLCanvasElement,
      config
    );
  }

}
